import activitystreamsRoutes from "./components/activitystreams/routes";
import appointmentsRoutes from "./components/appointments/routes";
import messagesRoutes from "./components/messages/routes";
import filesRoutes from "./components/files/routes";
import tasksRoutes from "./components/tasks/routes";
import supportRoutes from "./components/ai/support/routes";
import globalSearchRoutes from "./components/globalSearch/routes";
import administrationRoutes from "./components/administration/routes";
import directoryRoutes from "./components/directory/routes";
import membershipRoutes from "./components/memberships/routes";
import groupRoutes from "./components/groups/routes";
import onboardingRoutes from "./components/onboarding/routes";
import mapRoutes from "./components/memberMap/routes";
import chatRoutes from "./components/chat/routes";
import channelRoutes from "./components/channels/routes";
import blogRoutes from "./components/blogs/routes";
import articleRoutes from "./components/articles/routes";
import appCreatorRoutes from "./components/appCreator/routes";
import { lazy, Suspense } from "react";
import Loading from "./components/shared/Loading";
import pagesRoutes from "./components/pages/routes.tsx";
import CustomConfigurator from "./CustomConfigurator";
import { RouteObject } from "./helpers/tixxt-router";

const RedirectToStartpage = lazy(
  () => import("./components/tixxt/RedirectToStartpage"),
);

const appRoutes: RouteObject[] = [
  ...activitystreamsRoutes,
  ...appointmentsRoutes,
  ...messagesRoutes,
  ...filesRoutes,
  ...tasksRoutes,
  ...(Preload.current_network.availableModules?.includes("Support")
    ? supportRoutes
    : []),
  ...globalSearchRoutes,
  ...administrationRoutes,
  ...directoryRoutes,
  ...membershipRoutes,
  ...groupRoutes,
  ...onboardingRoutes,
  ...mapRoutes,
  ...chatRoutes,
  ...channelRoutes,
  ...blogRoutes,
  ...articleRoutes,
  ...appCreatorRoutes,
  ...pagesRoutes,
  {
    path: "/",
    element: (
      <Suspense fallback={<Loading />}>
        <RedirectToStartpage />
      </Suspense>
    ),
  },
];

// Custom entrypoints (e.g. custom/dbwv) can register additional SPA routes via
// CustomConfigurator.set("routes", [...]).
// We can't just spread them into appRoutes above because the custom entrypoint may
// load after this module is evaluated — the load order between entrypoints is not
// guaranteed. Instead, getRoutes() reads them lazily at call time and merges them
// with appRoutes. The result is cached by reference so we return a stable array as
// long as the custom routes don't change.
let _cachedCustomRoutes: RouteObject[] | null = null;
let _cachedRoutes: RouteObject[] | null = null;
export function getRoutes(): RouteObject[] {
  if (!Preload.current_member) return [];
  const customRoutes: RouteObject[] | null =
    CustomConfigurator.get("routes") || null;
  if (customRoutes && customRoutes !== _cachedCustomRoutes) {
    _cachedCustomRoutes = customRoutes;
    _cachedRoutes = [...customRoutes, ...appRoutes];
  }
  return _cachedRoutes || appRoutes;
}

export default appRoutes;
